import { IBaseComponentProps, NSButtonBlue, NSDialog, NSLoading, NSSpace, NSSpaceSizeType } from "namirasoft-site-react";
import { Component, createRef } from "react";
import RetrieveValue from "./RetrieveValue";
import { SecretRouterProps } from "../SecretRouterProps";
import { NSARouterMakerResult } from "namirasoft-account-react";

interface RetrieveValueProps extends IBaseComponentProps, NSARouterMakerResult, SecretRouterProps
{
    id: string;
    onClose: () => void;
}

interface RetrieveValueDialogState
{
    loading: boolean;
}

export default class RetrieveValueDialog extends Component<RetrieveValueProps, RetrieveValueDialogState>
{
    RetrieveValue = createRef<RetrieveValue>();
    constructor(props: RetrieveValueProps)
    {
        super(props);
        this.state = { loading: true };
    }

    override componentDidMount(): void
    {
        if (this.props.id)
            this.props.servers.secret.secret.GetValue(this.props.id).then(value =>
            {
                this.setState({ loading: false }, () =>
                {
                    this.RetrieveValue.current?.setValue(value);
                });
            }).catch(() =>
            {
                // The server already reported the error through the notifier.
                this.props.onClose();
            });
    }

    override render()
    {
        return <NSDialog
            center_dialog
            onClose={this.props.onClose}
            closeButton={{ out: true }}
        >
            {
                this.state.loading ?
                    <NSLoading />
                    :
                    <>
                        <RetrieveValue ref={this.RetrieveValue} />
                        <NSSpace size={NSSpaceSizeType.SMALL} />
                        <NSButtonBlue
                            title='Update'
                            onClick={{
                                showLoading: true,
                                action: async (onFinished) =>
                                {
                                    let value: string;
                                    try
                                    {
                                        value = this.RetrieveValue.current?.getValue() ?? "";
                                    }
                                    catch (error)
                                    {
                                        // Input validation errors are not reported by the server, so notify here.
                                        this.props.notifier.onError(error as Error);
                                        onFinished();
                                        return;
                                    }

                                    try
                                    {
                                        if (this.props.id && value)
                                        {
                                            await this.props.servers.secret.secret.UpdateValue(this.props.id, { value });
                                            this.props.notifier.onSuccess("The value has been successfully updated.");
                                            this.props.onClose();
                                        }
                                    } catch
                                    {
                                        // The server already reported the error through the notifier.
                                    } finally
                                    {
                                        onFinished();
                                    }
                                }
                            }}
                        />
                    </>
            }
        </NSDialog>;
    }
}